module.exports = __webpack_public_path__ + "img/201609-1.59f09289.jpg";